/*
 * @format
 */

import React from 'react';

import Topic from './Topic';
import WatchNavigationDiagram from './WatchNavigationDiagram';

// No copy of its own: the gestures are named on the illustration itself.
function WatchAppHelpNavigationScreen() {
  return (
    <Topic title="Navigation gestures" diagram={<WatchNavigationDiagram />} />
  );
}

export default WatchAppHelpNavigationScreen;
